import { useGetLookups } from '../../api/generated/lookup/lookup'
import {
  LookupType,
  type VisitCancellationReasonLookupItemOutContract,
} from '../../api/generated/pwrdbyQuickMDAdminsApi.schemas'

export type VisitCancellationReasonItem = VisitCancellationReasonLookupItemOutContract

/**
 * Visit-cancellation reason codes. Fetched once and cached for the whole session
 * (`staleTime: Infinity`). Called on login (see AuthenticatedLayout) to warm the cache so the
 * cancel popup always has the list ready and never needs a loading state; the popup calls the
 * same hook and reads the cached data.
 */
export const useVisitCancellationReasons = () =>
  useGetLookups<VisitCancellationReasonItem[]>(
    { type: LookupType.visitcancellationreasons },
    { query: { staleTime: Infinity } },
  )
